import React, { useState, useEffect, useRef } from "react";
import { Modal, Table } from "antd";
import "./index.less";
import axios from "axios";
import API from "@/api";
import GbiArrow from "../../../../../assets/images/gbiArrow.svg";
import DetailTable from "../detailTable";

function TableData(props) {
  const {
    data: initialData = {},
    question_id,
    drillable,
    drillActions,
    changSpining,
  } = props;
  const [historyStack, setHistoryStack] = useState([
    {
      title: drillable === "true" || drillable === true ? "" : "",
      rawData: initialData,
    },
  ]);
  useEffect(() => {
    setHistoryStack([
      {
        title: drillable === "true" || drillable === true ? "" : "",
        rawData: initialData,
      },
    ]);
  }, [initialData]);
  const currentStackItem = historyStack[historyStack.length - 1];
  const currentData = currentStackItem.rawData;

  // 2. 新增：使用 useRef 记录上一次点击的维度值
  const lastClickedDimRef = useRef(null);

  const [newDrillable, setNewDrillable] = useState(drillable);
  const { metric_fields = [], data: dData = [], dim_field = {} } = currentData;
  const [dimField, setDimField] = useState(currentData?.dim_field?.field);
  const [newActionId, setNewActionId] = useState(
    drillActions?.[0]?.action_id || "",
  );
  const [detailable, setDetailable] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);

  const dimFieldRef = useRef(dimField);
  const drillableRef = useRef(newDrillable);
  const actionIdRef = useRef(newActionId);

  const processTableData = (data) => {
    const columns = [
      ...(metric_fields || []).map((metric) => ({
        title: metric.name + `${metric.unit ? `（${metric.unit}）` : ""}`,
        dataIndex: metric.field,
        key: metric.field,
        // 可选：如果是数字，可以添加对齐方式
        align: "right",
      })),
    ];
    // 生成 columns 配置
    if (currentData?.dim_field) {
      columns.unshift({
        title: dim_field?.name,
        dataIndex: dim_field?.field,
        key: dim_field?.field,
      });
    }
    if (drillable === "true" || drillable === true) {
      columns.push({
        title: "操作",
        dataIndex: "action",
        render: (val, row) => {
          console.log(row, row?.[dim_field?.field], "这个row是啥");
          return (
            <span
              style={{
                cursor: "pointer",
                color: "#1C69FC",
              }}
              onClick={() => {
                // 3. 核心修复：防重判断
                // 如果当前点击的维度和上一次完全一样，直接 return，拦截重复请求
                if (lastClickedDimRef.current === row?.dimension_value) {
                  return;
                }
                if (newDrillable === "true" || newDrillable === true) {
                  changSpining(true);
                } else {
                  changSpining(false);
                }
                // 更新 ref 为当前点击的维度
                lastClickedDimRef.current = row?.[dim_field?.field];
                if (newDrillable === true || newDrillable === "true") {
                  axios
                    .post(API.getFilterAndNextData, {
                      question_id,
                      dim_field: dimFieldRef.current,
                      dim_value: row?.dimension_value || "",
                      // drill_path_id: actionIdRef?.current || "",
                    })
                    .then((res) => {
                      const newData = res?.data?.chart_data || {};
                      // 将新层级压入栈中
                      setHistoryStack((prev) => {
                        // 始终保留第一项（全部/根节点）的数据引用
                        const firstItem = prev[0] || {
                          title: "全部",
                          rawData: initialData,
                        };

                        // 返回：[根节点, ...中间所有层级, 新节点]
                        return [
                          { title: "全部", rawData: firstItem.rawData },
                          ...prev.slice(1),
                          { title: row?.[dim_field?.field], rawData: newData },
                        ];
                      });
                      setNewDrillable(res?.data?.drillable);
                      setDetailable(res?.data?.detailable);
                      setDimField(res?.data?.chart_data?.dim_field?.field);
                      setNewActionId(
                        res?.data?.drill_actions?.[0]?.action_id || "",
                      );
                      changSpining(false);
                    })
                    .catch((err) => {
                      console.error("下钻请求失败", err);
                    });
                } else {
                  console.log("不能下钻啦");
                  setDetailOpen(true);
                  lastClickedDimRef.current = row?.[dim_field?.field];
                }
              }}
            >
              更多
            </span>
          );
        },
      });
    }

    // 生成 dataSource
    const dataSource = (dData || []).map((row, index) => {
      let rowObj = {};
      if (currentData?.dim_field) {
        rowObj = {
          key: index, // Antd Table 需要唯一的 key
          [currentData.dim_field.field]: row[0],
        };
      }
      // const rowObj = {

      // };

      // 动态映射指标字段
      (currentData.metric_fields || []).forEach((metric, i) => {
        rowObj[metric.field] =
          typeof row[i + 1] === "number"
            ? row[i + 1].toLocaleString()
            : row[i + 1];
      });

      return rowObj;
    });

    return { columns, dataSource };
  };

  // 3. 处理面包屑点击（返回）
  const handleBreadcrumbClick = (index) => {
    // 如果点击的是当前层级，不做操作
    if (index === historyStack.length - 1) return;

    // 截取数组，保留到点击的那一层
    if (index === 0) {
      setHistoryStack((prev) => {
        console.log(prev.slice(0, index + 1));
        const item = prev.slice(0, index + 1)?.[0];
        return [{ ...item, title: "" }];
      });
    } else {
      setHistoryStack((prev) => prev.slice(0, index + 1));
    }
    lastClickedDimRef.current = "";
    setNewDrillable(true);
    setDimField(historyStack[index]?.rawData?.dim_field?.field);
  };

  useEffect(() => {
    dimFieldRef.current = dimField;
  }, [dimField]);

  useEffect(() => {
    drillableRef.current = newDrillable;
  }, [newDrillable]);

  useEffect(() => {
    actionIdRef.current = newActionId;
  }, [newActionId]);

  const { columns, dataSource } = processTableData(currentData);
  return (
    <div className="tableData">
      <Table columns={columns} dataSource={dataSource} pagination />

      {/* 4. 渲染面包屑导航 */}

      <div
        className="historyStack"
        style={{
          padding: drillable === "true" || drillable === true ? "" : "unset",
        }}
      >
        <div>
          {historyStack.map((item, index) => (
            <span key={index}>
              {/* 如果不是最后一项，或者虽然是最后一项但还有下级（理论上最后一项是当前），都可以点击 */}
              <span
                style={
                  index === historyStack.length - 1
                    ? {}
                    : {
                        cursor: "pointer",
                        color: "#1C69FC",
                      }
                } // 当前层级不加手型样式
                onClick={() => handleBreadcrumbClick(index)}
              >
                {item.title}
              </span>
              {/* 如果不是最后一项，显示分隔符 */}
              {index < historyStack.length - 1 && (
                <span
                  style={{
                    padding: "0 10px ",
                  }}
                >
                  <img
                    style={{
                      width: "8px",
                    }}
                    src={GbiArrow}
                    alt=" "
                  />
                </span>
              )}
            </span>
          ))}
        </div>
        <div
          style={{
            color: "#aaa",
          }}
        >
          {drillable === "true" || drillable === true
            ? "点击维度可下钻"
            : detailable
            ? "点击维度可下钻"
            : undefined}
        </div>
      </div>

      <Modal
        title="明细表"
        destroyOnHidden
        open={detailOpen}
        onCancel={() => {
          setDetailOpen(false);
        }}
        width={800}
        footer={null}
      >
        <DetailTable
          question_id={question_id}
          drillActions={newActionId}
          dimField={dimField}
          dimValue={lastClickedDimRef.current}
        />
      </Modal>
    </div>
  );
}

export default TableData;
